import { Cart } from "../containers/ProtectedContainer/Cart/Cart";
import { Checkout } from "../containers/ProtectedContainer/Checkout/Checkout";
import PersonalInfo from "../containers/ProtectedContainer/PersonalInfo/PersonalInfo";
import Wishlist from "../containers/ProtectedContainer/Wishlist/Wishlist";
import { Home } from "../containers/PublicContainer/Home/Home";
import { Login } from "../containers/PublicContainer/Login/Login";
import { ProductDetails } from "../containers/PublicContainer/ProductDetails/ProductDetails";
import { ProductsList } from "../containers/PublicContainer/ProductsList/ProductsList/ProductList";
import { Register } from "../containers/PublicContainer/Register/Register";
import { ResetPassword } from "../containers/PublicContainer/ResetPassword/ResetPassword";
import { VerifyResetPassword } from "../containers/PublicContainer/VerifyResetPassword/VerifyResetPassword";
import { InfoPage } from "../containers/PublicContainer/InfoPage/InfoPage";
import { Sitemap } from "../containers/PublicContainer/InfoPage/Sitemap";
import { LAUNCH_MODE } from "../siteConfig";

/**
 * The storefront routes. While LAUNCH_MODE is true these are filtered out of
 * ROUTES below and every one of their URLs redirects to `/` — the site is a
 * newsletter teaser until we open. Nothing here is deleted; flip LAUNCH_MODE
 * in src/siteConfig.js to bring the shop back.
 */
const STOREFRONT_ROUTES = [
  {
    name: 'Login',
    id: 'login',
    url: '/login',
    component: <Login />,
    isPrivate: false,
    isAuthScreen: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Register',
    id: 'register',
    url: '/register',
    component: <Register />,
    isPrivate: false,
    isAuthScreen: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Reset',
    id: 'reset-password',
    url: '/reset',
    component: <ResetPassword />,
    isPrivate: false,
    isAuthScreen: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'VerifyResetPassword',
    id: 'verify-reset-password',
    url: '/forgotPassword',
    component: <VerifyResetPassword />,
    isPrivate: false,
    isAuthScreen: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Product List',
    id: 'productList',
    url: '/products',
    component: <ProductsList />,
    isPrivate: false
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Product Details',
    id: 'productDetails',
    url: '/productDetails',
    component: <ProductDetails />,
    isPrivate: false
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Cart',
    id: 'cart',
    url: '/cart',
    component: <Cart />,
    isPrivate: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Checkout',
    id: 'checkout',
    url: '/checkout',
    component: <Checkout />,
    isPrivate: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Profile',
    id: 'profile',
    url: '/profile',
    component: <PersonalInfo />,
    isPrivate: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
  {
    name: 'Wishlist',
    id: 'wishlist',
    url: '/wishlist',
    component: <Wishlist />,
    isPrivate: true
    //   roles: USER_ROLES,
    //   Icon: DashboardIcon,
  },
];

/** Every URL the storefront owns — used to redirect them to `/` during launch mode. */
export const STOREFRONT_URLS = STOREFRONT_ROUTES.map((route) => route.url);

/**
 * The static footer pages. These stay reachable during launch mode; the `:slug`
 * route resolves against INFO_PAGES in InfoPage/infoPagesContent.js.
 */
const INFO_ROUTES = [
  {
    name: 'Home',
    id: 'home',
    url: '/',
    component: <Home />,
    isPrivate: false
  },
  {
    name: 'Sitemap',
    id: 'sitemap',
    url: '/sitemap',
    component: <Sitemap />,
    isPrivate: false
  },
  {
    name: 'Info Page',
    id: 'info-page',
    url: '/:slug',
    component: <InfoPage />,
    isPrivate: false
  },
];

export const ROUTES = LAUNCH_MODE
  ? INFO_ROUTES
  : [...STOREFRONT_ROUTES, ...INFO_ROUTES];